
import * as ActionTypes from "../ActionTypes";

export const GetGoalTypeAction = (params) => ({
  type: ActionTypes.GOAL_TYPE_GET_REQUEST,
  params,
});

export const AddGoalTypeAction = (params, callback) => ({
  type: ActionTypes.GOAL_TYPE_ADD_REQUEST,
  params,
  callback
});

export const UpdateGoalTypeAction = (params) => ({
  type: ActionTypes.GOAL_TYPE_UPDATE_REQUEST,
  params,
});

export const DeleteGoalTypeAction = (params, callback) => ({
  type: ActionTypes.GOAL_TYPE_DELETE_REQUEST,
  params,
  callback
});

export const GetGoalSubtypeAction = (params) => ({
  type: ActionTypes.GOAL_SUBTYPE_GET_REQUEST,
  params,
});

export const AddGoalSubtypeAction = (params) => ({
  type: ActionTypes.GOAL_SUBTYPE_ADD_REQUEST,
  params,
});

export const UpdateGoalSubtypeAction = (params) => ({
  type: ActionTypes.GOAL_SUBTYPE_UPDATE_REQUEST,
  params,
});

export const DeleteGoalSubtypeAction = (params) => ({
  type: ActionTypes.GOAL_SUBTYPE_DELETE_REQUEST,
  params,
});
